export default {
  SET_AVAILABLE_IDENTIFIERS: 'SET_AVAILABLE_IDENTIFIERS',
  SET_BLOCKS: 'SET_BLOCKS',
  GET_BLOCKS: 'GET_BLOCKS',
}
